export function LogoGrayExtraSmall({ ...props }: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='48' height='40' viewBox='0 0 48 40' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g opacity='0.25'>
        <path
          d='M6.96148 0C10.6175 0 13.5837 3.00831 13.5837 6.71622V23.9965C13.5837 27.7044 10.6175 30.7127 6.96148 30.7127C3.30545 30.7127 0.339233 27.7044 0.339233 23.9965V6.71622C0.339233 3.00831 3.30545 0 6.96148 0Z'
          fill='url(#paint0_linear_2081_39206)'
        />
        <path
          d='M24.0001 9.28729C27.6561 9.28729 30.6223 12.2956 30.6223 16.0035V33.2838C30.6223 36.9917 27.6561 40 24.0001 40C20.344 40 17.3778 36.9917 17.3778 33.2838V16.0035C17.3778 12.2956 20.344 9.28729 24.0001 9.28729Z'
          fill='url(#paint1_linear_2081_39206)'
        />
        <path
          d='M41.0385 0.717102C44.6945 0.717102 47.6608 3.72541 47.6608 7.43332V31.115C47.6608 34.8229 44.6945 37.8312 41.0385 37.8312C37.3825 37.8312 34.4163 34.8229 34.4163 31.115V7.43332C34.4163 3.72541 37.3825 0.717102 41.0385 0.717102Z'
          fill='url(#paint2_linear_2081_39206)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_2081_39206'
          x1='16.3085'
          y1='-7.101'
          x2='-1.03565'
          y2='33.441'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6B7280' />
          <stop offset='1' stopColor='#F3F4F6' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2081_39206'
          x1='33.3471'
          y1='2.1688'
          x2='16.0029'
          y2='42.7108'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4B5563' />
          <stop offset='1' stopColor='#E5E7EB' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_2081_39206'
          x1='48.4713'
          y1='3.21819'
          x2='30.9123'
          y2='40.0894'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#374151' />
          <stop offset='1' stopColor='#D1D5DB' />
        </linearGradient>
      </defs>
    </svg>
  )
}
